import { Tabs } from '@bfe/moly';
import { Modal } from '@web3/base-components';
import { useFm } from '@web3/base-hooks';
import { initialWindowType } from '@/hooks/media';

import styles from './index.module.scss';
import { DOUBLE_LIMIT, SINGLE_LIMIT } from '@/utils/constant';

type Props = {
  visible: boolean;
  onClose?: () => void;
  defaultTab?: TabKey;
};

export enum TabKey {
  USER = 'user',
  PROJECT = 'project',
}

const VotingPoints = ({
  visible = false,
  onClose,
  defaultTab = TabKey.USER,
}: Props) => {
  const fm = useFm();
  const { isMobile } = initialWindowType;

  const ToUser = (
    <div className={styles.content}>
      <ul>
        <li>{fm('earnVotingPointsMethod')}</li>
        <li>{fm('excludeZeroFeePairVolume')}</li>
        <li>{fm('updateHourlyVotingAndBbsolData')}</li>
        <li>
          {fm('votingPointsLimit')}
          <ul>
            <li>{fm('dailyVotingPointsLimit', { amount: SINGLE_LIMIT })}</li>
            <li>{fm('dailyVotingPointsLimit2', { amount: SINGLE_LIMIT })}</li>
            <li>
              {fm('participantTotalDailyVotingPointsLimit', {
                amount: DOUBLE_LIMIT,
              })}
            </li>
          </ul>
        </li>
      </ul>
    </div>
  );

  const ToProject = (
    <div className={styles.content}>
      <span>{fm('earnVotingPointsWays')}</span>
      <ul>
        <li>{fm('supportersVoteDaily')}</li>
        <li>{fm('socialMediaBonusPointsWeekly')}</li>
        <li>{fm('mentorGrantBonusPoints')}</li>
      </ul>
    </div>
  );

  const FooterBtn = (
    <button className={styles.footer} onClick={() => onClose?.()}>
      {fm('i_know')}
    </button>
  );

  return (
    <>
      <Modal
        isMobile={isMobile}
        direction={!isMobile ? 'center' : 'bottom'}
        title={fm('votingPoints')}
        cancelText={false}
        onCancel={() => {
          onClose?.();
        }}
        open={visible}
        onOpenAutoFocus={(e) => e.preventDefault()}
        footer={FooterBtn}
        footerWrapper={styles.footerWrapper}
      >
        <div className={styles.wrapper}>
          <div className={styles.topText}>{fm('votingPointsRuleInPopup')}</div>
          <Tabs
            className="w-full"
            size="s"
            tabType="buttonBg"
            isEqualDivided
            tabBarGutter={4}
            tabBarWithContentGutter={16}
            items={[
              {
                key: TabKey.USER,
                label: fm('toSupporter'),
                children: ToUser,
              },
              {
                key: TabKey.PROJECT,
                label: fm('aiProjects'),
                children: ToProject,
              },
            ]}
            defaultActiveKey={defaultTab}
          />
        </div>
      </Modal>
    </>
  );
};

export default VotingPoints;
